<h2 mat-dialog-title style="text-align: center">
  {{ title }}
</h2>
<mat-dialog-content class="mat-typography">
  <div class="row-layout" style="justify-content: stretch; margin-top: 16px">
    <div style="flex: 1">
      <form>
        <app-input
          label="E-Mail-Addresse"
          #mail
          [required]="true"
          [value]="emailAddress"
          (valueChange)="addressChange($event)"
        ></app-input>
      </form>
    </div>
  </div>
  <div *ngIf="isWaiting" style="margin: 0.5rem">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </div>
  <div *ngIf="logs.length > 0">
    <div
      class="row-layout"
      style="justify-content: space-between; align-items: flex-start"
    >
      <div
        [ngStyle]="{
          color: lastSuccess ? 'green' : 'red'
        }"
        style="padding-top: 8px"
      >
        {{
          lastSuccess
            ? "Letzte E-Mail versandt."
            : "Letzte E-Mail nicht versandt."
        }}
      </div>
      <div style="margin-right: 2rem; margin-bottom: 0.5rem">
        <button mat-button (click)="showLog(!logVisible)">
          <span>Verlauf</span>
          <mat-icon *ngIf="!logVisible">expand_more</mat-icon>
          <mat-icon *ngIf="logVisible">expand_less</mat-icon>
        </button>
      </div>
    </div>
    <div
      *ngIf="logVisible"
      style="max-height: 60vh; overflow: auto; min-height: 6rem"
    >
      <table style="width: 100%; border-spacing: 8px">
        <tr>
          <th>Status / Datum</th>
          <th>Absender</th>
          <th>E-Mail</th>
        </tr>
        <tbody>
          <ng-container *ngFor="let item of logs; let $idx = index">
            <tr
              [ngClass]="{
                'table-grey-bg': $idx % 2 === 0
              }"
            >
              <td
                class="cb-column"
                style="white-space: nowrap; width: 20%; padding: 0.25rem"
              >
                <div
                  [ngStyle]="{
                    color: item.state ? 'green' : 'red'
                  }"
                  style="text-align: center"
                >
                  {{ item.state ? "OK" : "Fehler" }}
                </div>
                <div>{{ item.time }}</div>
              </td>
              <td class="cb-column" style="padding-left: 8px">
                {{ item.sender_fname }} <br />{{ item.sender_lname }}
              </td>
              <td class="cb-column" style="padding-left: 8px">
                {{ item.email }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout"
  style="justify-content: space-between"
>
  <button mat-button (click)="doCancel()">Abbrechen</button>
  <button
    mat-button
    [disabled]="!canSend"
    style="margin-left: 1rem"
    (click)="doSend()"
  >
    Senden
  </button>
</div>
